/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import EmptyStateBlocksImg from './empty-state-blocks.svg';
import IssuesHighlightImg from './issues-highlight.svg';

export const EmptyStateBlocks = () => <img src={EmptyStateBlocksImg} alt="" width={171.25} />;

const imageTopMarginStyles = css({
	marginTop: token('space.200'),
});

export const EmptyStateImage = () => (
	<img src={IssuesHighlightImg} alt="" width={336} css={imageTopMarginStyles} />
);
